import { DocumentReference, FestivalUser } from ".";

export class UserAction {

     // constructor(isCompleted: boolean, completedBy: DocumentReference) {
     //      this.isCompleted = isCompleted;
     //      this.completedBy = completedBy;
     //      //this.completedOn = new Date();
     // }
     
     isCompleted: boolean;
     completedBy?: DocumentReference;
     completedOn?: Date;
}